import { createTheme, Shadows } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    requestNotification: Palette['primary'];
    transferNotification: Palette['primary'];
  }

  interface PaletteOptions {
    requestNotification?: PaletteOptions['primary'];
    transferNotification?: PaletteOptions['primary'];
  }
}

const theme = createTheme({
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Arial, sans-serif',
    h1: {
      fontWeight: 600,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  palette: {
    primary: {
      main: 'rgb(14, 14, 15)',
    },
    secondary: {
      main: '#E3E5E9',
    },
    background: {
      default: 'rgba(243,243,247,1)',
    },
    success: {
      main: 'rgb(146, 255, 175)',
    },
    info: {
      main: '#3882ff',
    },
    requestNotification: {
      main: '#99d1ff',
    },
    transferNotification: {
      main: '#ffb48a',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiAutocomplete: {
      styleOverrides: {
        popper: {
          border: '1px solid black',
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          paddingLeft: '24px',
          paddingRight: '24px',
          paddingBottom: '16px',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: 'rgba(243,243,247,1)',
          color: 'rgb(14, 14, 15)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        sizeLarge: {
          height: '50px',
        },
        root: {
          textTransform: 'none',
          borderRadius: '9999px',
          paddingLeft: '24px',
          paddingRight: '24px',
          height: '40px',
          fontSize: '16px',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        sizeSmall: {
          height: '20px',
          '>*': {
            fontSize: '12px',
          },
        },
        colorDefault: {
          backgroundColor: 'rgba(243,243,247,1)',
        },
      },
    },
  },
  shadows: [
    ...(createTheme().shadows.map((shadow, i) =>
      i === 1 || i === 2 ? `0px 4px 20px rgba(0, 0, 0, ${0.15 * i});` : shadow,
    ) as Shadows),
  ],
});

export default theme;
